import { theme } from "..";

import { TBaseSVG } from "../../models";

export default ({ title, color, className, onClick, style, id }: TBaseSVG) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        className={className}
        onClick={onClick}
        style={style}
        id={id}
        strokeWidth={0.1}
    >
        <title>{title}</title>
        <path
            d="M13.9038 21.0538C13.6161 21.341 13.2595 21.4846 12.8342 21.4846C12.4088 21.4846 12.0526 21.341 11.7654 21.0538L2.96537 12.2538C2.82051 12.1089 2.70673 11.9422 2.62405 11.7536C2.54135 11.5649 2.5 11.3637 2.5 11.15V3.99998C2.5 3.59101 2.64776 3.23878 2.94328 2.94328C3.23878 2.64776 3.59101 2.5 3.99998 2.5H11.15C11.3564 2.5 11.5541 2.54028 11.7431 2.62085C11.9321 2.7014 12.096 2.80983 12.2346 2.94615L21.0346 11.7616C21.3282 12.0551 21.4766 12.4138 21.4798 12.8375C21.483 13.2612 21.341 13.6166 21.0538 13.9038L13.9038 21.0538ZM12.8303 20L19.9846 12.85L11.1543 3.99998H3.99998V11.15L12.8303 20ZM6.49885 7.74995C6.84575 7.74995 7.14099 7.62853 7.38458 7.3857C7.62816 7.14287 7.74995 6.848 7.74995 6.5011C7.74995 6.1542 7.62853 5.85896 7.3857 5.61538C7.14287 5.37179 6.848 5.25 6.5011 5.25C6.1542 5.25 5.85896 5.37142 5.61538 5.61425C5.37179 5.85708 5.25 6.15195 5.25 6.49885C5.25 6.84575 5.37142 7.14099 5.61425 7.38457C5.85708 7.62816 6.15195 7.74995 6.49885 7.74995Z"
            fill={color ?? theme.gray600}
        />
    </svg>
);
